import { Routes } from '@angular/router';
import { RoleGuard, MaintenanceGuard, ProfilingEnabledGuard } from '@meddata/guards';
import { Role } from '@meddata/constants';
import { NotFoundRedirect } from '@meddata/utilities';
import { DoctorProfilingGuard, FirstLoginGuard, LoginGuard } from '@meddata/guards/login.guard';

export const ROUTES: Routes = [
	{
		path: 'login',
		loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent),
		canActivate: [MaintenanceGuard]
	},
	{
		path: 'first-login',
		title: 'Primo Accesso - Cambio Password',
		loadComponent: () =>
			import('./features/login/password-recovery/first-login/first-login.component').then(
				(c) => c.FirstLoginComponent
			),
		canActivate: [MaintenanceGuard, FirstLoginGuard]
	},
	{
		path: 'reset-password',
		title: 'Reimposta Password',
		loadComponent: () =>
			import('./features/login/password-recovery/reset-password/reset-password.component').then(
				(c) => c.ResetPasswordComponent
			),
		canActivate: [MaintenanceGuard]
	},
	{
		path: 'forgot-password',
		pathMatch: 'full',
		redirectTo: 'reset-password'
	},
	{
		path: 'profilazione-medico',
		title: 'Profilazione Medica',
		loadComponent: () =>
			import('./features/users/doctor-profiling/doctor-profiling.component').then(
				(c) => c.DoctorProfilingComponent
			),
		canActivate: [MaintenanceGuard, ProfilingEnabledGuard, DoctorProfilingGuard]
	},

	{
		path: 'maintenance',
		loadComponent: () =>
			import('@meddata/components/maintenance/maintenance.component').then(
				(c) => c.MaintenanceComponent
			)
	},
	{
		path: 'not-found',
		canActivate: [MaintenanceGuard],
		loadComponent: () =>
			import('@meddata/components/not-found/not-found.component').then((c) => c.NotFoundComponent)
	},

	{
		path: '',
		loadComponent: () =>
			import('./features/navbar/navbar.component').then((c) => c.NavbarComponent),
		canActivate: [MaintenanceGuard],
		canActivateChild: [LoginGuard],
		children: [
			{
				path: '',
				redirectTo: 'home',
				pathMatch: 'full'
			},
			{
				path: 'home',
				title: 'ICORS | Home',
				loadChildren: () => import('./features/home/home.routes').then((m) => m.HOME_ROUTES)
			},
			{
				path: 'statistiche',
				title: 'ICORS | Statistiche',
				loadChildren: () =>
					import('./features/statistics/statistics.routes').then((m) => m.STATISTICS_ROUTES)
			},
			{
				path: 'pazienti',
				title: 'ICORS | Pazienti',
				loadChildren: () =>
					import('./features/surveys/surveys.routes').then((m) => m.SURVEYS_ROUTES)
			},
			{
				path: 'profilo',
				title: 'ICORS | Il mio profilo',
				canActivate: [ProfilingEnabledGuard],
				loadComponent: () =>
					import('./features/users/user-detail/user-detail.component').then(
						(m) => m.UserDetailComponent
					)
			},
			{
				path: 'utenti',
				title: 'ICORS | Utenti',
				loadChildren: () => import('./features/users/users.routes').then((m) => m.USERS_ROUTES),
				canActivate: [RoleGuard],
				data: { role: Role.ADMIN }
			},
			{
				path: 'help',
				title: 'ICORS | Guida',
				loadChildren: () => import('./features/help/help.routes').then((m) => m.HELP_ROUTES)
			}
		]
	},

	{
		path: '**',
		redirectTo: NotFoundRedirect
	}
];
